import indicators from './indicators'
import navigation from './navigations'
import shared from './shared'
import steps from './steps'

export default {
  navigation,
  steps,
  indicators,
  shared,
}
